import { Component } from '@theme/component';
import { morph } from '@theme/morph';
import { StandardEvents } from '@shopify/events';

/**
 * Rodwin — swap reactivo entre el link de WhatsApp ("Notificarme cuando
 * llegue" / "Consultar por WhatsApp") y el <product-form-component> normal
 * en blocks/buy-buttons.liquid, según el estado de disponibilidad
 * (metafield + inventario) de la variante seleccionada.
 *
 * Las dos ramas son mutuamente excluyentes en el servidor (if/elsif), así
 * que esto es un swap de ESTRUCTURA completa, no solo de texto. Igual que
 * assets/rdw-disponibilidad-badge.js, no reimplementa la lógica de
 * resolución de estado: al cambiar de variante, toma el HTML que el
 * servidor ya volvió a renderizar (detail.html del ProductSelectEvent) y
 * morfea los hijos completos de este bloque — mismo mecanismo que usan los
 * componentes nativos (assets/product-sku.js, assets/product-inventory.js,
 * assets/product-form.js), no un patch custom.
 *
 * Necesario porque, a diferencia de <product-form-component> (que sí
 * escucha productSelect vía assets/product-form.js), cuando la variante
 * inicial es agotada/a-pedido ese componente ni existe en el DOM — está
 * reemplazado por el link de WhatsApp — así que no hay nada que reaccione
 * al volver a una variante vendible.
 */
class RdwBuyButtonsBlock extends Component {
  connectedCallback() {
    super.connectedCallback();
    const target = this.closest('[id*="ProductInformation-"]');
    target?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const target = this.closest('[id*="ProductInformation-"]');
    target?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  /**
   * @param {import('@shopify/events').ProductSelectEvent} event
   */
  #handleProductSelect = (event) => {
    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        const newBlock = detail.html.querySelector('rdw-buy-buttons-block');
        if (!newBlock) return;

        morph(this, newBlock, { childrenOnly: true });
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[rdw-buy-buttons-block] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('rdw-buy-buttons-block')) {
  customElements.define('rdw-buy-buttons-block', RdwBuyButtonsBlock);
}
